module.exports = __webpack_public_path__ + "static/the-quran-81eacc4a12f85a24a97127f178b6c98d.jpg";